<template>
  <div v-if="hasFooter" class="data-footer">
    <div class="data-footer__left">
      <p v-for="(src, i) in normalizedSources" :key="i">{{ src.text }}</p>
    </div>
    <div class="data-footer__right" v-if="normalizedLinks.length">
      <!-- NOSONAR -->
      <a v-for="(lnk, i) in normalizedLinks" :key="i" :href="lnk.url" :target="lnk.isExternal ? '_blank' : '_self'"
        class="data-footer__link" @click="handleLinkClick()">{{ lnk.text }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataCuesFooter',
  props: {
    sources: [Array, String],
    links: Array,
    footNoteText: String,
    learnMoreText: String,
    learnMoreLink: String,
    isExternalLink: Boolean,
    learnMoreTaggingAttributes: [Object, String]
  },
  computed: {
    normalizedSources() {
      const src = this.sources ?? this.footNoteText ?? [];
      const arr = Array.isArray(src) ? src : (src ? [src] : []);
      return arr.map(t => ({ text: t }));
    },
    normalizedLinks() {
      const links = this.links || [];
      if (Array.isArray(links) && links.length) return links;
      if (this.learnMoreText && this.learnMoreLink) {
        return [{ text: this.learnMoreText, url: this.learnMoreLink, isExternal: !!this.isExternalLink }];
      }
      return [];
    },
    hasFooter() {
      return this.normalizedSources.length > 0 || this.normalizedLinks.length > 0;
    }
  },
  methods: {
    parseTagging(input) {
      if (!input) return null;
      if (typeof input === 'object') return input;
      try { return JSON.parse(input); } catch { return null; }
    },
    handleLinkClick() {
      try {
        const payload = this.parseTagging(this.learnMoreTaggingAttributes);
        if (payload && typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push(payload);
        }
      } catch (error) {
        console.error('JSON parse error:', error);
      }
    }
  }
}
</script>

<style lang="scss" src="./DataCuesFooter.scss"></style>
